import { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import utils, { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import { BASE, URLS, APIS, SF_NOTI_HIST_INFO } from "@/tra/tancis/ptli/ptl/ntcmgmt/services/PtliNtcMgmtService";

/*
 * Notifice History Details
 * !== 알림현황(SMS/Mail) 상세 ==!
 */
export const PTLI0801002S = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0001", "auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { openPopup } = usePopup();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const { notiSendUuid } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "PTL0022" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Notifice Information !== 알림 정보 ==!
        notiHistInfo: useForm({
            defaultSchema: SF_NOTI_HIST_INFO,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Notifice History Details !== 알림 이력 상세 조회 ==!
        getNotiHistInfo: useFetch({
            api: () => APIS.getNotiHistInfo(notiSendUuid),
            enabled: !!notiSendUuid,
            onSuccess: (data) => {
                const ntcMgmtInfo = data.ntcMgmtInfo.content;

                form.notiHistInfo.setValues(ntcMgmtInfo);
            },
            onError: (error) => {},
            showToast: true,
        }),
        // Execute Resend !== 알림 재발송 ==!
        executeResend: useFetch({
            api: (data) => APIS.executeResend({ ...data }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.ptl.00747", // Resend has been processed. !== 재발송 처리 되었습니다. ==!
                });
                fetch.getNotiHistInfo.fetch();
            },
            onError: (error) => {
                console.log(error);
                const data = error.response.data;
                if (error.response.status === 400) {
                    form.notiHistInfo.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: data.errorMessage,
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // on Resend Button Click Event Handler  !== 재발송 버튼 클릭 이벤트 핸들러 ==!
        onResdBtnClick: () => {
            modal.openModal({
                content: "msg.ptl.00746", // Would you like to resend? !== 재발송 하시겠습니까? ==!
                onConfirm: () => {
                    const notiHist = form.notiHistInfo.getValues();
                    fetch.executeResend.fetch(notiHist);
                },
            });
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getNotiHistInfo.fetch();
        form.notiHistInfo.setEditable(false);
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.notiNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.notiMsgCn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.notiTp}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.usrNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.usrEmlAddr}></Group.Control>
                                <Group.Control {...form.notiHistInfo.schema.usrMoblNo}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.notiSendStatCd}></Group.Control>
                                <Group.Control {...form.notiHistInfo.schema.sendDtm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.sndrNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiHistInfo.schema.sndrEmlAddr}></Group.Control>
                                <Group.Control {...form.notiHistInfo.schema.sndrTelno}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0801001q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role={"apply"}
                        onClick={() => {
                            handler.onResdBtnClick();
                        }}
                    >
                        {t("B_RESD")}
                    </Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
